export class AbstractImagePreview {
  isImagePreview() {
    return (
      this.img.classList.contains('img-preview') &&
      this.img.parentNode.classList.contains('ql-image-preview')
    );
  }

  getBlotEl() {
    return this.isImagePreview() ? this.img.parentNode : this.img;
  }

  getImageWidth() {
    const el = this.getBlotEl();
    return Math.round(el.getBoundingClientRect().width);
  }
}

export default AbstractImagePreview;
